import { BaseService } from '../../infra/base.service'
import type { WaitlistEntriesRepository } from './waitlist-entries.repository'
import type { WaitlistEntryEntity } from './waitlist-entry.entity'

export class WaitlistEntriesService extends BaseService<WaitlistEntryEntity> {
    constructor(private rep: WaitlistEntriesRepository) {
        super(rep)
    }
}
